<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0">
      <div class="actions-left col-lg-6 row p-0 m-0">
       <span class="col-lg-6 m-0 p-0 text-left"> 
        <button v-bind:class="{'font-weight-bold': showActive}" class="status-button" @click="showActive = true">{{ $t('active') }}</button><span> | </span><button v-bind:class="{'font-weight-bold': !showActive}" class="status-button" @click="showActive = false">{{ $t('archive') }}</button>
       </span>
      </div>
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addCoachingSession">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked" style="margin-bottom: 1rem!important;"></SearchBar>
    <div class="d-flex justify-content-end" style="gap: 2rem">
      <div role="group" class="form-group">
        <label>{{ $t('startDate') }}</label>
        <CInput type="date" v-model="startDate" ></CInput>
      </div>
      <div role="group" class="form-group">
        <label>{{ $t('endDate') }}</label>
        <CInput type="date" v-model="endDate" ></CInput>
      </div>
    </div>
    <CTableWrapper ref="table" hover striped :caption="$t('coachingSessions')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
    <!-- generate link popup -->
    <BasePopUp v-if="showGenerateLink" @popUpClosed="closeGenerateLinkPopup">
      <template v-slot:body>
        <div class="d-flex flex-column p-3" style="gap: 1rem">
          <span class="nav-item-title">{{ $t('shareLink') }}</span>
          <input type="text" class="form-control" v-model="generatedLink" readonly>
          <div class="d-flex justify-content-between mt-3">
            <ButtonComponent 
              :class="{ disabled: copied }"
              @handleClick="copyLink" 
              :label="!copied ? $t('copy') : $t('copied')" 
              :background-color="!copied ? '#004043' : '#B99550'" 
              :borderColor="!copied ? '#004043' : '#B99550'" 
              color="#FCFCFC" 
            />
            <ButtonComponent @handleClick="closeGenerateLinkPopup" :label="$t('close')" background-color="#004043" color="#FCFCFC" />
          </div>
        </div>
      </template>
    </BasePopUp>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from "@/controls/PaginatedTable.vue";
import SearchBar from "@/controls/SearchBar.vue";
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase } from "@/helpers/utils.js";
import BasePopUp from "@/controls/shareLink/BasePopUp.vue";
import ButtonComponent from "@/controls/shareLink/ButtonComponent.vue";
import { API_HELPER } from "@/helpers/api.js";

export default {
  components: { CTableWrapper, SearchBar, BasePopUp, ButtonComponent},
  data () {
    return {
      currentPage: 1,
      searchText: '',
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'date', label: i18n.t('date'), sortable: true },
        { key: 'title', label: i18n.t('title'), sortable: true },
      ],
      sorterValue: { column: 'date', asc: false },
      loading: false,
      showActive: true,
      startDate: undefined,
      endDate: undefined,
      showGenerateLink: false,
      generatedLink: '',
      copied: false,
      currentItem: null
    }
  },
  computed: {
    ...mapState('coachingSessions', ['getCoachingSessionsOutput']),
    ...mapState('coachingSessions', ['deleteCoachingSessionByIdOutput']),
    ...mapState('coachingSessions', ['putCoachingSessionStatusOutput']),
    ...mapState('spaces', ['getSpaceByCoachingSessionOutput']), 
    actions() {
      return [
        { key: 'view', label: this.$t('view') },
        { key: 'duplicate', label: this.$t('duplicate') },
        { key: 'shareLink', label: this.$t('shareLink') },
        { key: 'changeStatus', label: this.showActive ? this.$t('archiveClass') : this.$t('activateClass') },
        { key: 'delete', label: this.$t('delete') },
      ];
    },
    coachingSessionsInfo: function() {
      return this.getCoachingSessionsOutput ? this.getCoachingSessionsOutput : null;
    },
    getSpaceByCoachingSessionInfo: function() {
      return this.getSpaceByCoachingSessionOutput && this.getSpaceByCoachingSessionOutput.data && this.getSpaceByCoachingSessionOutput.data.length ? this.getSpaceByCoachingSessionOutput.data : [];
    },
    items: function()
    {
      return (this.coachingSessionsInfo?.data || []).map(session => ({
        ...session,
        date: session.date.replace('T', ' ').slice(0, 16)
      }));
    },
    pages: function()
    {
      return this.coachingSessionsInfo ? this.coachingSessionsInfo.totalPages : 1;
    }
  },
  mounted: function()
  {
    this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    ...mapActions('coachingSessions', ['getCoachingSessions']),
    ...mapActions('coachingSessions', ['deleteCoachingSessionById']),
    ...mapActions('coachingSessions', ['putCoachingSessionStatus']),
    ...mapActions('spaces', ['getSpaceByCoachingSession']),
    addCoachingSession()
    {
      this.$router.push({name: "CoachingSessionAdd"});
    },
    rowClicked (item, index) {
      this.$router.push({name: "CoachingSessionEdit", query: { id: item.id }, params: { name: item.name } });
    },
    showGenerateLinkPopup(currentItem, coachSpaceId) {
      this.showGenerateLink = true;
      this.generatedLink = this.generateLink(currentItem, coachSpaceId);
    },
    closeGenerateLinkPopup() {
      this.showGenerateLink = false;
      this.generatedLink = '';
      this.copied = false;
    },
    generateLink(currentItem, coachSpaceId) {
      const routePath = 'board-game';
      const coachingSessionSpace = currentItem.coachingSessionSpaces !== 'Students' ? `&space=${coachSpaceId}` : '';
      const info = `id=${currentItem.id}&sku=${currentItem.sku}${coachingSessionSpace}`; // get session id, sku and space id from coach if the session is not for students
      return API_HELPER.pathJoin([process.env.VUE_APP_WEBSITE_URL, `${routePath}?${info}`]);
    },
    copyLink() {
      navigator.clipboard.writeText(this.generatedLink).then(() => {
        this.copied = true;
      }).catch((error) => {
        this.copied = false;
        alert(this.$t('errorCopyLink'), error);
      });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({name: "CoachingSessionEdit", query: { id: item.id }, params: { name: item.name } });
          break;
        }
        case 'duplicate':
        {
          this.$router.push({name: "CoachingSessionAdd", query: { id: item.id }, params: { name: item.name } });
          break;
        }
        case 'shareLink':
        {
          this.currentItem = item;
          this.getSpaceByCoachingSession(`?id=${item.id}`)
          break;
        }
        case 'changeStatus':
        {
          if(confirm(this.$i18n.t('confirmChangeStatus'))){
            this.putCoachingSessionStatus(item.id);
          }
          break;
        }
        case 'delete':
        {
          if(confirm(this.$i18n.t('confirmDelete'))){
            this.deleteCoachingSessionById(item.id);
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {

      if(this.startDate === undefined)
      {
        // Get the current date
        const currentDate = new Date();

        // Subtract one week (7 days)
        const oneWeekAgo = new Date(currentDate);
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

        // Format the date as a string in ISO format (YYYY-MM-DD)
        this.startDate = oneWeekAgo.toISOString().slice(0, 10);
      }

      if(this.endDate === undefined)
      {
        let currentDate = new Date();
        // Add 1 month to the current date
        let endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate());
        // Convert the new date to ISO string format
        this.endDate = endDate.toISOString().slice(0, 10);
      }

      this.currentPage = currentPage;
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));
      input.status = this.showActive;
      input.startDate = this.startDate;
      input.endDate = this.endDate + 'T23:59:59.999Z';
      this.getCoachingSessions(input); 
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    getCoachingSessionsOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    },
    deleteCoachingSessionByIdOutput: function(val)
    {
      this.loading = val === null;
      if(val !== null)
      {
        this.updateItemsRequested(this.currentPage, this.itemsPerPage);
      }
    },
    putCoachingSessionStatusOutput: function(val)
    {
      this.loading = val === null;
      if(val !== null)
      {
        this.updateItemsRequested(this.currentPage, this.itemsPerPage);
      }
    },
    showActive: function()
    {
      this.updateItemsRequested(1, this.itemsPerPage);
    },
    startDate: function(newVal, oldVal)
    {
      if(oldVal !== undefined) {
        this.startDate = newVal;
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    endDate: function(newVal, oldVal)
    {
      if(oldVal !== undefined) {
        this.endDate = newVal;
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    getSpaceByCoachingSessionInfo: function(val)
    {
      this.showGenerateLinkPopup(this.currentItem, this.currentItem.coachingSessionSpaces !== 'Students' ? val[0].id : null); // pass the space id from coach
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}

.locked-out
{
  background-color: darkred !important;
  color: white;
}
</style> 